/* unplugin-vue-components disabled */import { render } from "./zhejiangmap copy.vue?vue&type=template&id=37a10e6a&scoped=true"
import script from "./zhejiangmap copy.vue?vue&type=script&lang=js"
export * from "./zhejiangmap copy.vue?vue&type=script&lang=js"

import "./zhejiangmap copy.vue?vue&type=style&index=0&id=37a10e6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a10e6a"]])

export default __exports__